module.exports = __webpack_public_path__ + "media/application/assets/images/views/companies/investor-696024755661ee73d9b70f93f3b0b618.svg";